<template>
    <el-dialog
        :title="(isForm ? (formId ? '编辑接口' : '添加接口') : '查看接口') + dialogTitle"
        width="640px"
        :model-value="modelValue"
        @close="closed"
        :close-on-click-modal="false"
    >
        <el-form ref="formRef" :model="formData" :rules="isForm ? formRules : {}" label-width="120px" style="max-width: 540px">
            <el-row>
                <el-col :span="24">
                    <el-form-item label="接口名称" prop="name">
                        <el-input v-if="isForm" v-model="formData.name" placeholder="请输入接口名称"></el-input>
                        <span v-else>{{ formData.name }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="http请求方法" prop="method">
                        <el-select v-if="isForm" v-model="formData.method" clearable placeholder="http请求方法">
                            <el-option v-for="item in methodOptions" :key="item.value" :label="item.label" :value="item.value" />
                        </el-select>
                        <span v-else>{{ formData.method }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="访问路径" prop="path">
                        <el-input v-if="isForm" v-model="formData.path" placeholder="请输入访问路径"></el-input>
                        <span v-else>{{ formData.path }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="所属分组">
                        <el-select v-if="isForm" v-model="formData.group" clearable placeholder="所属分组">
                            <el-option
                                v-for="item in configGroupList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                        <span v-else>{{ formData.group_name }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="请求参数" prop="params">
                        <el-input v-if="isForm" v-model="formData.params" placeholder="请输入请求参数" type="textarea"></el-input>
                        <span v-else>{{ formData.params }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="返回参数" prop="results">
                        <el-input
                            v-if="isForm"
                            v-model="formData.results"
                            placeholder="请输入返回参数"
                            type="textarea"
                        ></el-input>
                        <span v-else>{{ formData.results }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="返回示例" prop="example">
                        <el-input
                            v-if="isForm"
                            v-model="formData.example"
                            placeholder="请输入返回示例"
                            type="textarea"
                        ></el-input>
                        <span v-else>{{ formData.example }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="排序值">
                        <el-input-number
                            v-if="isForm"
                            v-model="formData.list_order"
                            class="mx-4"
                            :min="0"
                            :max="999999"
                            controls-position="right"
                        />
                        <span v-else>{{ formData.list_order }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="状态">
                        <el-radio-group v-if="isForm" v-model="formData.status">
                            <el-radio :value="1">正常</el-radio>
                            <el-radio :value="0">停用</el-radio>
                        </el-radio-group>
                        <div v-else>{{ formData.status ? '正常' : '停用' }}</div>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="接口描述" placeholder="请输入接口描述">
                        <el-input v-if="isForm" v-model="formData.remark" type="textarea"></el-input>
                        <div v-else>{{ formData.remark }}</div>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <template #footer>
            <span class="dialog-footer">
                <el-button @click="closed">取消</el-button>
                <el-button v-if="isForm" type="primary" :loading="submitLoading" @click="onConfirm">确定</el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script setup>
import { defineEmits, defineProps, onMounted, ref, watch } from 'vue'
import { addApi, getApiDetail, putApi } from '@/api/api.js'
import { ElMessage } from 'element-plus'
import { getDictDataOptions } from '@/api/dictdata.js'
import { getDictDataSelect } from '@/utils/common.js'
import { getApiGroupOptionLists } from '@/api/apigroup.js'

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    isForm: {
        type: Boolean,
        default: false
    },
    formId: {
        type: String,
        required: false
    },
    groupList: {
        type: Array,
        default: () => []
    },
    apiId: {
        type: String,
        required: false
    }
})
const emits = defineEmits(['update:modelValue', 'updateForm'])
const methodOptions = ref([])

// 表单源
const formData = ref({
    name: '',
    method: '',
    path: '',
    group: '',
    group_name: '',
    remark: '',
    params: '',
    results: '',
    example: '',
    list_order: 1,
    status: 1,
    visible: 1,
    id: props.apiId
})

// 验证规则

const formRules = ref({
    name: [
        {
            required: true,
            trigger: 'blur',
            message: '请输入接口名称'
        }
    ],
    method: [
        {
            required: true,
            trigger: 'blur',
            message: '请输入http请求方法'
        }
    ],
    path: [
        {
            required: true,
            trigger: 'blur',
            message: '请输入访问路径'
        }
    ]
})
const dialogTitle = ref('')
const submitLoading = ref(false)
const formRef = ref(null)
const configGroupList = ref([])
/**
 * 关闭
 */
const closed = () => {
    dialogTitle.value = ''
    emits('update:modelValue', false)
    formRef.value.resetFields()
}

/**
  确定按钮点击事件
 */

const onConfirm = async () => {
    if (!props.isForm) return
    if (props.formId !== '') {
        await doputApi()
    } else {
        await doaddApi()
    }
}

// 修改
const doputApi = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        const params = formData.value.params ? JSON.parse(formData.value.params) : formData.value.params
        const results = formData.value.results ? JSON.parse(formData.value.results) : formData.value.results
        const id = formData.value.id
        const err = await putApi({ ...formData.value, params, results, id }).catch((err) => {
            submitLoading.value = false
            return err
        })
        if (err) return
        // 修改成功
        emits('updateForm')
        ElMessage.success('修改成功！')
        submitLoading.value = false
        closed()
    })
}

// 添加
const doaddApi = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        const params = formData.value.params ? JSON.parse(formData.value.params) : formData.value.params
        const results = formData.value.results ? JSON.parse(formData.value.results) : formData.value.results
        const err = await addApi({ ...formData.value, params, results }).catch((err) => {
            submitLoading.value = false
            return err
        })
        if (err) return
        // 添加成功
        emits('updateForm')
        ElMessage.success('添加成功！')
        submitLoading.value = false
        closed()
    })
}

// 获取api详情
const getApiDetailFun = async () => {
    const data = await getApiDetail(props.formId)
    Object.keys(data).forEach((k) => {
        data[k] = data[k] === null ? '' : data[k]
    })
    const params = data.params ? JSON.stringify(data.params) : data.params
    const results = data.results ? JSON.stringify(data.results) : data.results
    formData.value = { ...data, params, results }
    dialogTitle.value = data.name
}
const getList = async () => {
    const dictData = await getDictDataOptions({ dict_code: 'open_api_method' })
    methodOptions.value = getDictDataSelect(dictData)
}
const getApiGroupOptionListsData = async () => {
    const data = await getApiGroupOptionLists()
    configGroupList.value = data.map((v) => ({ label: v.name, value: v.id }))
}
onMounted(() => {
    getList()
    getApiGroupOptionListsData()
})

// 只有formId有的时候，才会去请求数据
watch(
    () => props.modelValue,
    (newVal) => {
        if (newVal && props.formId) {
            getApiDetailFun()
        } else {
            formData.value = {
                name: '',
                method: methodOptions?.value.filter((v) => v.value === 'POST')[0].value,
                path: '',
                group: '',
                group_name: '',
                remark: '',
                params: '',
                results: '',
                example: '',
                list_order: 1,
                status: 1,
                visible: 1,
                id: props.apiId
            }
        }
    }
)
</script>

<style lang="scss" scoped>
.el-textarea {
    height: 70px;
    :deep(.el-textarea__inner) {
        height: 70px;
    }
}
</style>
